import { defineStore } from 'pinia';
import type { ToastMessageOptions } from 'primevue/toast';
import { ref } from 'vue';

export const useToastStore = defineStore('toastStore', () => {
  const toasts = ref<Map<number, ToastMessageOptions>>(new Map());

  const addToast = (hashCode: number, message: ToastMessageOptions): void => {
    toasts.value.set(hashCode, message);
  };

  const hasToast = (hashCode: number): boolean => {
    return toasts.value.has(hashCode);
  };

  const getToast = (hashCode: number): ToastMessageOptions | undefined => {
    return toasts.value.get(hashCode);
  };

  const removeToast = (hashCode: number): void => {
    toasts.value.delete(hashCode);
  };

  return { addToast, hasToast, getToast, removeToast };
});
